var React = require('react');

function IcInfoWhite (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},[React.createElement("path",{"d":"M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 14.4c-3.529 0-6.4-2.871-6.4-6.4 0-3.529 2.871-6.4 6.4-6.4 3.529 0 6.4 2.871 6.4 6.4 0 3.529-2.871 6.4-6.4 6.4z","transform":"translate(-211 -784) translate(64 729) translate(10 55) translate(137)","key":0}),React.createElement("path",{"d":"M7.2 7.2h1.6V12H7.2V7.2zm0-3.2h1.6v1.6H7.2V4z","transform":"translate(-211 -784) translate(64 729) translate(10 55) translate(137)","key":1})]));
}

IcInfoWhite.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = IcInfoWhite;

IcInfoWhite.default = IcInfoWhite;
